import LessonIcon from "components/icons/adminIcons/LessonIcon";
import DefaultBaseMenu from "./components/DefaultBaseMenu";
import ScheduleIcon from "components/icons/adminIcons/ScheduleIcon";
import InteractiveIcon from "components/icons/adminIcons/InteractiveIcon";
import GpaIcon from "components/icons/adminIcons/GpaIcon";
import TestIcon from "components/icons/adminIcons/TestIcon";
import ClubIcon from "components/icons/adminIcons/ClubIcon";
import { useNavigate } from "react-router-dom";
import { currentUser } from "services/users/authSlice";
import { useSelector } from "react-redux";
import { FaPeopleGroup } from "react-icons/fa6";
import { FaUserDoctor } from "react-icons/fa6";
import { IoLibrary } from "react-icons/io5";
import { successToast } from "services/globalFunctions";

const Dashboard = () => {
  var user = useSelector(currentUser);
  const navigate = useNavigate();
  return (
    <div>
      <div className="mt-3 grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3 lg:gap-8 ">
        <DefaultBaseMenu
          onClick={() => {
            if (user.is_manager) {
              navigate("/admin/lessons");
            } else {
              navigate("/admin/teacher_ls");
            }
          }}
          text={user.is_manager ? "Хичээлүүд" : "Миний хичээлүүд"}
          icon={<LessonIcon />}
          className=" bg-gradient-to-tr from-gradOrange-0 to-gradOrange-100 "
        />
        <DefaultBaseMenu
          onClick={() => {
            if (user.is_manager) {
              navigate("/admin/schedule");
            } else {
              navigate("/admin/teacher_sch");
            }
          }}
          text={"Хичээлийн хуваарь"}
          icon={<ScheduleIcon />}
          className=" bg-gradient-to-tr from-gradPink-0 to-gradPink-100 "
        />
        {user.is_manager ? (
          <DefaultBaseMenu
            onClick={() => {
              navigate("/admin/course");
            }}
            text={"Ангиуд"}
            icon={<FaPeopleGroup className="h-20 w-20 text-white" />}
            className="bg-gradient-to-tr from-gradGreen-0 to-gradGreen-100"
          />
        ) : (
          <DefaultBaseMenu
            onClick={() => {
              navigate("/admin/journal");
            }}
            text={"Журнал"}
            icon={<GpaIcon />}
            className="bg-gradient-to-tr from-gradGreen-0 to-gradGreen-100"
          />
        )}{" "}
        <DefaultBaseMenu
          onClick={() => {
            window.location.replace("http://library.edumongolia.mn:8088/");
          }}
          text={"Номын сан"}
          icon={<IoLibrary className="h-20 w-20 text-white" />}
          className=" bg-gradient-to-tr from-gradLibrary-0 to-gradLibrary-100 "
        />
        <DefaultBaseMenu
          onClick={() => {
            successToast("Тун удахгүй");
          }}
          text={"Шалгалт"}
          icon={<TestIcon />}
          className=" bg-gradient-to-tr from-gradBlue-0 to-gradBlue-100 "
        />
        <DefaultBaseMenu
          onClick={() => {
            successToast("Тун удахгүй");
          }}
          text={"Дугуйлан"}
          icon={<ClubIcon />}
          className=" bg-gradient-to-tr from-gradPurple-0 to-gradPurple-100 "
        />
        <DefaultBaseMenu
          onClick={() => {
            successToast("Тун удахгүй");
          }}
          text={"Интерактив хичээл"}
          icon={<InteractiveIcon />}
          className=" bg-gradient-to-tr from-gradYellow-0 to-gradYellow-100 "
        />
        <DefaultBaseMenu
          onClick={() => {
            successToast("Тун удахгүй");
          }}
          text={"Эмч"}
          icon={<FaUserDoctor className="h-20 w-20 text-white" />}
          className=" bg-gradient-to-tr from-gradDoctor-0 to-gradDoctor-100 "
        />
      </div>
    </div>
  );
};

export default Dashboard;
